import { combineReducers } from 'redux';

import getCrmCustomerReducer from './getCrmCustomer';
import getMyRewardWidgetInfoReducer from './myRewardWidgetInfo';

export const loyaltyReducer = combineReducers({ 
  getMyRewardWidgetInfoReducer,
  getCrmCustomerReducer
});
